import { render, staticRenderFns } from "./data-lake.vue?vue&type=template&id=5d4d8fdd&scoped=true&"
import script from "./data-lake.ts?vue&type=script&lang=ts&"
export * from "./data-lake.ts?vue&type=script&lang=ts&"
import style0 from "./data-lake.scss?vue&type=style&index=0&id=5d4d8fdd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d8fdd",
  null
  
)

export default component.exports